import { useParams } from "react-router-dom";
import classes from "./ProjectDetails.module.css";
import { featuredPortfolio } from "../../data";

const ProjectDetails = (props) => {
  const params = useParams();

  const project = featuredPortfolio.find((p) => p.id === +params.id);
  console.log(project);

  return (
    <section className={classes.container}>
      
      <div className={classes.circleTwo}></div>
      <div className={classes.left}>
        <div className={classes.circleOne}></div>
        <img src={project.img} alt="project" />
      </div>

      <div className={classes.right}>
        <h3>{project.title}</h3>
        <a
          className={classes.a}
          href={project.href}
          target="_blank"
          rel="noreferrer"
        >
          <button className={classes.visit}>VISIT</button>
        </a>
        <a
          className={classes.a}
          href={project.git}
          target="_blank"
          rel="noreferrer"
        >
          <button className={classes.git}>GIT HUB</button>
        </a>
      </div>
    </section>
  );
};

export default ProjectDetails;
